const translations: Record<string, string> = {}

export default translations;
